/**
 * Returns false if its single operand that can be converted to true; otherwise, returns true.
 * @param {Function} fn
 * @returns {any}
 *
 * @example
 * cons result = not(isFiledEmpty)(state[field])
 * instead of
 * cons result = !isFieldEmpty(state[field])
 */
const not = (fn) => (...args) => !fn(...args)

export default not
